import React, { useState, useEffect } from "react";

/** Components */
import {
  TableContainer,
  //   Fab,
  TableHead,
  TableRow,
  TextField,
  TableCell,
  TableBody,
  Table,
  Paper,
  TablePagination,
  Button,
  Checkbox,
  ButtonGroup,
  TableFooter,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tabs,
  Tab,
} from "@mui/material";
import ButtonWithAPICallComponent from "../../commons/ButtonWithAPICall.component";
import SelectStatusButton from "../../commons/SelectStatusButton";
import { FilterBy } from "../../commons/filter.component";
import LoadingProgress from "../../commons/LoadingProgress.component";

/** Icons */
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";

/** Api & Function */
import {
  // createBank,
  getBanks,
  postSync,
  updateBankStatus,
  editBank,
  getBankById,
  updateBactStatus,
  createBact,
  getCurrency,
  updateBact,
} from "./../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Package */
import { useTranslation } from "react-i18next";

/** Hook */
import { useHistory, useParams } from "react-router-dom";
import { usePagination } from "./../../commons/customHook";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

const initialFilter = {
  id: "",
  vi_name: "",
};

const Banks = () => {
  // custom hook
  const [t] = useTranslation();
  const [page, setPage, rowsPerPage, setRowsPerPage] = usePagination();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  // state
  const [data, setData] = useState(null);
  const [changeIds, setChangeIds] = useState([]); //ids cua nhung bank can cap nhat
  // eslint-disable-next-line no-unused-vars
  const [selectedRow, setSelectedRow] = useState(null);
  const [filter, setFilter] = useState({ ...initialFilter });
  const [isOpen, setOpen] = useState(false);

  // effect
  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN NGÂN HÀNG"));
    if (!data)
      getBanks().then((res) => {
        res.code === 200 && setData(res.data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setPage(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  // methods
  const handleRowClick = (e, row, index) => {
    if (e.target.type === "checkbox") return;
    history.push(`/banks/${row.id}`);
  };
  const handleSuccessEdit = (res) => {
    setData((prev) => prev.map((item) => (item.id === res.data.id ? res.data : item)));
    setSelectedRow(null);
  };
  const handleCheckBoxClick = (id) => {
    if (changeIds.includes(id)) setChangeIds((prev) => prev.filter((item) => item !== id));
    else setChangeIds((prev) => [...prev, id]);
  };
  const handleUpdateStatus = (selectedStatus) => {
    return updateBankStatus({ ids: changeIds, action: selectedStatus.action });
  };
  const handleUpdateStatusResponse = (res, selectedStatus) => {
    if (res.code === 200) {
      let newStatus;
      switch (selectedStatus.action) {
        case 0:
          newStatus = "DEACTIVATED";
          break;
        case 1:
          newStatus = "ACTIVATED";
          break;
        case 4:
          setChangeIds([]);
          newStatus = "DELETED";
          break;
        default:
          break;
      }
      setData((prev) => prev.map((item) => (changeIds.includes(item.id) ? { ...item, status: newStatus } : item)));
    }
  };

  return (
    <div>
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <ButtonWithAPICallComponent title="Đồng bộ dữ liệu" api={() => postSync({ object: "bank" })}>
            <RefreshIcon />
          </ButtonWithAPICallComponent>
          <Button onClick={() => setOpen((prev) => !prev)}>
            <SearchIcon />
          </Button>
        </ButtonGroup>
      </div>
      <Collapse in={isOpen} sx={{ marginBottom: "20px" }}>
        <TextField sx={{ margin: "5px" }} value={filter.id} onChange={(e) => setFilter((prev) => ({ ...prev, id: e.target.value }))} label="ID" />
        <TextField sx={{ margin: "5px" }} value={filter.vi_name} onChange={(e) => setFilter((prev) => ({ ...prev, vi_name: e.target.value }))} label={t("Tên ngân hàng (VN)")} />
      </Collapse>
      {!data ? (
        <LoadingProgress />
      ) : (
        <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={{ border: "0.5px solid lightgray" }}>ID</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Mã số")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Tên ngân hàng (VN)")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Địa chỉ (VN)")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Tên ngân hàng (English)")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Địa chỉ (English)")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("NH trung gian")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Swiftcode NHTG")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Trạng thái")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>
                  <SelectStatusButton disabled={!changeIds.length} api={handleUpdateStatus} response={handleUpdateStatusResponse} />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.filter((item) => item.id.toString().contains(filter.id) && item.vi_name.contains(filter.vi_name)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).length ? (
                data
                  .filter((item) => item.id.toString().contains(filter.id) && item.vi_name.contains(filter.vi_name))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    return (
                      <TableRow key={row.id} onClick={(e) => row.status !== "DELETED" && handleRowClick(e, row, index)} hover style={{ cursor: "pointer" }}>
                        <TableCell style={{ border: "0.5px solid lightgray" }}>{row.id} </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }}>{row.code}</TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} width="10%" align="left">
                          {row.vi_name}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} width="15%" align="left">
                          {row.vi_address}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} width="10%" align="left">
                          {row.en_name}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} width="15%" align="left">
                          {row.en_address}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }}>{row.ibank}</TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }}>{row.ibswiftcode}</TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray", whiteSpace: "nowrap" }} width="7%">
                          {t(row.status)}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} width="15%">
                          <Checkbox disabled={row.status === "DELETED"} checked={changeIds.includes(row.id)} onClick={handleCheckBoxClick.bind(this, row.id)} />
                        </TableCell>
                      </TableRow>
                    );
                  })
              ) : (
                <TableRow>
                  <TableCell colSpan={50}>{t("Không có dữ liệu")}</TableCell>
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  count={data.filter((item) => item.id.toString().contains(filter.id) && item.vi_name.contains(filter.vi_name)).length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={(e, newPage) => setPage(newPage)}
                  onRowsPerPageChange={setRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      )}
      <EditDialog onSuccess={handleSuccessEdit} onClose={() => history.push(`/banks${location.search}`)} />
    </div>
  );
};

export default Banks;

// const CreateButton = ({ onSuccess, ...buttonProps }) => {
//   const [open, setOpen] = useState(false);
//   const [t] = useTranslation();
//   const [inputData, setInputData] = useState({
//     code: "",
//     vi_name: "",
//     en_name: "",
//     vi_address: "",
//     en_address: "",
//     cif: "",
//     account_number: "",
//     swiftcode: "",
//     ibswiftcode: "",
//     interbank: "",
//   });
//   const handleCreate = () => {
//     return createBank(inputData);
//   };
//   const handleResponse = (res) => {
//     if (res.code === 200) {
//       setOpen(false);
//       onSuccess && onSuccess(res);
//     }
//   };
//   return (
//     <React.Fragment>
//       <Fab color="primary" style={{ position: "fixed", bottom: 20, right: 20 }} onClick={() => setOpen((prev) => !prev)}>
//         <AddIcon />
//       </Fab>
//       <Dialog open={open} onClose={() => setOpen(false)} align="center">
//         <DialogTitle>{t("Thêm mới ngân hàng")}</DialogTitle>
//         <DialogContent align="center">
//           <TextField label={t("Mã số")} value={inputData.code} onChange={(e) => setInputData((prev) => ({ ...prev, code: e.target.value }))} fullWidth sx={{ margin: "5px 0" }} />
//           <TextField label={t("Tên ngân hàng (VN)")} value={inputData.vi_name} onChange={(e) => setInputData((prev) => ({ ...prev, vi_name: e.target.value }))} fullWidth sx={{ margin: "5px 0" }} />
//           <TextField
//             label={t("Tên ngân hàng (English)")}
//             value={inputData.en_name}
//             onChange={(e) => setInputData((prev) => ({ ...prev, en_name: e.target.value }))}
//             fullWidth
//             sx={{ margin: "5px 0" }}
//           />
//           <TextField label={t("Địa chỉ(VN)")} value={inputData.vi_address} onChange={(e) => setInputData((prev) => ({ ...prev, vi_address: e.target.value }))} fullWidth sx={{ margin: "5px 0" }} />
//           <TextField
//             label={t("Địa chỉ (English)")}
//             value={inputData.en_address}
//             onChange={(e) => setInputData((prev) => ({ ...prev, en_address: e.target.value }))}
//             fullWidth
//             sx={{ margin: "5px 0" }}
//           />
//           <TextField label="CIF" value={inputData.cif} onChange={(e) => setInputData((prev) => ({ ...prev, cif: e.target.value }))} fullWidth sx={{ margin: "5px 0" }} />
//           <TextField
//             label={t("Số tài khoản")}
//             value={inputData.account_number}
//             onChange={(e) => setInputData((prev) => ({ ...prev, account_number: e.target.value }))}
//             fullWidth
//             sx={{ margin: "5px 0" }}
//           />
//           <TextField label="Swift code" value={inputData.swiftcode} onChange={(e) => setInputData((prev) => ({ ...prev, swiftcode: e.target.value }))} fullWidth sx={{ margin: "5px 0" }} />
//           <TextField
//             label={t("Ngân hàng trung gian")}
//             value={inputData.interbank}
//             onChange={(e) => setInputData((prev) => ({ ...prev, interbank: e.target.value }))}
//             fullWidth
//             sx={{ margin: "5px 0" }}
//           />
//           <TextField
//             label={t("Swift code ngân hàng trung gian")}
//             value={inputData.ibswiftcode}
//             onChange={(e) => setInputData((prev) => ({ ...prev, ibswiftcode: e.target.value }))}
//             fullWidth
//             sx={{ margin: "5px 0" }}
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpen(false)}>{t("Hủy")}</Button>
//           <ButtonWithAPICallComponent variant="contained" disabled={!Object.keys(inputData).every((key) => inputData[key])} api={handleCreate} response={handleResponse}>
//             {t("Tạo mới")}
//           </ButtonWithAPICallComponent>
//         </DialogActions>
//       </Dialog>
//     </React.Fragment>
//   );
// };
const EditDialog = ({ onClose, onSuccess }) => {
  const [data, setData] = useState(); // dữ liệu của bank
  const [t] = useTranslation();
  const [inputData, setInputData] = useState();
  const [tab, setTab] = useState(0);
  const { id } = useParams();

  const getData = () => {
    getBankById(id).then((res) => {
      if (res.code !== 200) return;
      setData(res.data);
      setInputData(res.data);
    });
  };
  useEffect(() => {
    if (!id) return;
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  const handleSave = () => {
    return editBank(id, inputData);
  };
  const handleResponse = (res) => {
    if (res.code === 200) {
      onSuccess && onSuccess(res);
    }
  };
  if (data && inputData)
    return (
      <Dialog open={Boolean(id)} onClose={onClose} align="center" maxWidth={false}>
        <DialogTitle>{t("Chỉnh sửa thông tin ngân hàng")}</DialogTitle>
        <DialogContent style={{}}>
          <div style={{ display: "flex", justifyContent: "center", marginBottom: 10 }}>
            <Tabs value={tab} onChange={(e, value) => setTab(value)}>
              <Tab value={0} label="Thông tin cơ bản" />
              <Tab value={1} label="Tài khoản ngân hàng" />
            </Tabs>
          </div>
          <div style={{ display: tab == 0 ? "flex" : "none", flexDirection: "column" }}>
            <TextField label={t("Mã số")} value={inputData.code || ""} onChange={(e) => setInputData((prev) => ({ ...prev, code: e.target.value }))} sx={{ margin: "5px 0", width: 450 }} />
            <TextField
              label={t("Tên ngân hàng (VN)")}
              value={inputData.vi_name || ""}
              onChange={(e) => setInputData((prev) => ({ ...prev, vi_name: e.target.value }))}
              sx={{ margin: "5px 0", width: 450 }}
            />
            <TextField
              label={t("Địa chỉ (VN)")}
              value={inputData.vi_address || ""}
              onChange={(e) => setInputData((prev) => ({ ...prev, vi_address: e.target.value }))}
              sx={{ margin: "5px 0", width: 450 }}
            />
            <TextField
              label={t("Tên ngân hàng (English)")}
              value={inputData.en_name || ""}
              onChange={(e) => setInputData((prev) => ({ ...prev, en_name: e.target.value }))}
              sx={{ margin: "5px 0", width: 450 }}
            />
            <TextField
              label={t("Địa chỉ (English)")}
              value={inputData.en_address || ""}
              onChange={(e) => setInputData((prev) => ({ ...prev, en_address: e.target.value }))}
              sx={{ margin: "5px 0", width: 450 }}
            />
            <TextField
              label={t("Ngân hàng trung gian")}
              value={inputData.ibank || ""}
              onChange={(e) => setInputData((prev) => ({ ...prev, ibank: e.target.value }))}
              sx={{ margin: "5px 0", width: 450 }}
            />
            <TextField
              label={t("Swift code ngân hàng trung gian")}
              value={inputData.ibswiftcode || ""}
              onChange={(e) => setInputData((prev) => ({ ...prev, ibswiftcode: e.target.value }))}
              InputLabelProps={{ style: {} }}
              sx={{ margin: "5px 0", width: 450 }}
            />
          </div>
          <div hidden={tab !== 1}>
            <BactTable onChange={getData} data={data.bank_accounts || []} setData={(func) => setData((prev) => ({ ...prev, bank_accounts: func(prev.bank_accounts) }))} />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>{t("Quay lại")}</Button>
          <div hidden={tab !== 0} style={{ marginLeft: 10 }}>
            <ButtonWithAPICallComponent variant="contained" api={handleSave} response={handleResponse}>
              {t("Lưu")}
            </ButtonWithAPICallComponent>
          </div>
        </DialogActions>
      </Dialog>
    );
  else return "";
};

const BactTable = ({ setData, data, onChange }) => {
  const total = data?.length;
  const isAllow = true;
  const [changeIds, setChangeIds] = useState([]); //ids cua nhung bank can cap nhat
  const [page, setPage, rowsPerPage, setPerPage] = usePagination();
  const [isDialogOpen, setDialogOpen] = useState(false);
  const { t } = useTranslation();
  const handleCheckBoxClick = (e, id) => {
    e.stopPropagation();
    if (changeIds.includes(id)) setChangeIds((prev) => prev.filter((item) => item !== id));
    else setChangeIds((prev) => [...prev, id]);
  };
  const handleRowClick = (e, row) => {
    e.stopPropagation();
    setDialogOpen(row);
  };

  const handleUpdateStatus = (selectedStatus) => {
    return updateBactStatus({ ids: changeIds, action: selectedStatus.action });
  };
  const handleUpdateStatusResponse = (res, selectedStatus) => {
    if (res.code === 200) {
      let newStatus;
      switch (selectedStatus.action) {
        case 0:
          newStatus = "DEACTIVATED";
          break;
        case 1:
          newStatus = "ACTIVATED";
          break;
        case 4:
          setChangeIds([]);
          newStatus = "DELETED";
          break;
        default:
          break;
      }
      setData((prev) => prev.map((item) => (changeIds.includes(item.id) ? { ...item, status: newStatus } : item)));
    }
  };
  const handleSuccessCreate = (res) => {
    if (res.code !== 200) return;
    setDialogOpen(false);
    onChange?.();
  };
  return (
    <div>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>{t("Tên người thụ hưởng")}</TableCell>
              <TableCell>{t("Số tài khoản")}</TableCell>
              <TableCell>{t("Swiftcode")}</TableCell>
              <TableCell>{t("Tên hiển thị ngân hàng")}</TableCell>
              <TableCell>{t("Loại tiền")}</TableCell>
              <TableCell>{t("Trạng thái")}</TableCell>

              <TableCell>
                <SelectStatusButton disabled={!changeIds.length} api={handleUpdateStatus} response={handleUpdateStatusResponse} />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length ? (
              data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                <TableRow key={row.id} onClick={(e) => handleRowClick(e, row, index)} hover style={{ cursor: "pointer" }}>
                  <TableCell>{row.id}</TableCell>
                  <TableCell align="left">{row.act_holder}</TableCell>
                  <TableCell align="left" style={{ whiteSpace: "nowrap" }}>
                    {row.act_number}
                  </TableCell>
                  <TableCell align="left">{row.swift_code}</TableCell>
                  <TableCell>{row.bank_code}</TableCell>
                  <TableCell>{row.currency}</TableCell>
                  <TableCell>{t(row.status)}</TableCell>
                  <TableCell width="200px">
                    <Checkbox disabled={row.status === "DELETED"} checked={changeIds.includes(row.id)} onClick={(e) => handleCheckBoxClick(e, row.id)} />
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={50}>{t(isAllow ? "Không có dữ liệu" : "No permission")}</TableCell>
              </TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination rowsPerPageOptions={[10, 100, 150]} count={total || 0} rowsPerPage={rowsPerPage} page={page} onPageChange={setPage} onRowsPerPageChange={setPerPage} />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
      <Button style={{ marginTop: 5, textDecoration: "underline" }} color="success" onClick={() => setDialogOpen(true)}>
        Thêm tài khoản mới
      </Button>
      <CreateNewBactDialog key={isDialogOpen} open={isDialogOpen} onClose={() => setDialogOpen(false)} onSuccess={handleSuccessCreate} />
    </div>
  );
};
const CreateNewBactDialog = ({ open, onClose, onSuccess }) => {
  const initialData = Boolean(open && open !== true) ? open : null;
  const isUpdate = Boolean(initialData);
  const { t } = useTranslation();
  const [inputData, setInputData] = useState({});
  const { id } = useParams();
  const handleCreate = () => {
    if (isUpdate) return updateBact(initialData.id, { ...inputData, bank_id: id, currency_id: inputData.currency?.id, currency: inputData.currency?.code });
    return createBact({ ...inputData, bank_id: id, currency_id: inputData.currency?.id, currency: inputData.currency?.code });
  };
  const handleResponse = (res) => {
    if (res.code === 200) {
      onSuccess?.(res);
    }
  };
  useEffect(() => {
    if (!isUpdate) return;
    setInputData({ ...initialData });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  return (
    <Dialog open={open} onClose={onClose} align="center" maxWidth={false}>
      <DialogTitle>{t("Thêm tài khoản ngân hàng")}</DialogTitle>
      <DialogContent>
        <div style={{ paddingTop: 10, display: "flex", flexDirection: "column" }}>
          <TextField
            label={t("Tên người thụ hưởng")}
            value={inputData.act_holder || ""}
            onChange={(e) => setInputData((prev) => ({ ...prev, act_holder: e.target.value }))}
            sx={{ margin: "5px 0", width: 450 }}
          />
          <TextField
            label={t("Số tài khoản")}
            value={inputData.act_number || ""}
            onChange={(e) => setInputData((prev) => ({ ...prev, act_number: e.target.value }))}
            sx={{ margin: "5px 0", width: 450 }}
          />
          <TextField
            label={t("Swiftcode")}
            value={inputData.swift_code || ""}
            onChange={(e) => setInputData((prev) => ({ ...prev, swift_code: e.target.value }))}
            sx={{ margin: "5px 0", width: 450 }}
          />
          <TextField
            label={t("Tên hiển thị ngân hàng")}
            value={inputData.bank_code || ""}
            onChange={(e) => setInputData((prev) => ({ ...prev, bank_code: e.target.value }))}
            sx={{ margin: "5px 0", width: 450 }}
          />
          <FilterBy
            sx={{ margin: "5px 0", width: 450 }}
            label={t("Loại tiền")}
            getDataFunc={() => getCurrency({ status: 1 })}
            getOptionLabel={(option) => option?.code}
            value={inputData.currency}
            onChange={(e, newValue) => setInputData((prev) => ({ ...prev, currency: newValue }))}
            setDefaultFunc={(option) => setInputData((prev) => ({ ...prev, currency: option.find((i) => i.id == initialData.currency_id) }))}
            triggerSetDefaultFunc={isUpdate}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("Quay lại")}</Button>
        <div style={{ marginLeft: 10 }}>
          <ButtonWithAPICallComponent variant="contained" api={handleCreate} response={handleResponse}>
            {t("Tạo mới")}
          </ButtonWithAPICallComponent>
        </div>
      </DialogActions>
    </Dialog>
  );
};
